import { Form, Row, Select, Input } from "antd";
import styled, { createGlobalStyle } from "styled-components";

export const StyledSelectForm = styled(Select)`
  font-weight: 400;

  .anticon.arrow-icon {
    color: ${"#bfbfbf"};
  }
  &.ant-select-open .anticon.arrow-icon {
    transform: rotate(180deg);
  }
`;

export const StyledTextArea = styled(Input.TextArea)`
  &.ant-input {
    line-height: 24px;
  }
`;

export const GlobalModalStyles = createGlobalStyle`
  .ant-modal.add-comment-modal .ant-form > .ant-form-item:last-child {
    margin-top: 24px;
  }
`;

export const ContentWrapper = styled.div`
  padding: 0 24px;

  .scrollable-wrapper.withScroll .anticon.arrow-up {
    top: -12px;
    right: -3px;
  }
`;

export const FooterButtonRow = styled(Row)`
  width: 100%;
  padding: 16px 24px;
  border-top: 1px solid ${"#f5f5f5"};
`;

export const TitleRow = styled(Row)`
  .anticon > svg {
    height: 28px;
    width: 28px;
    color: ${"#f0f0f0"};

    > path:last-child {
      color: ${"#434343"};
    }
  }
`;

export const AddChangeRequestDrawerForm = styled(Form)`
  height: 100%;

  .content-change-request-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    .ant-radio-wrapper {
      width: 100%;
    }
  }

  .ant-form-item-label > label {
    height: 20px;
  }
`;
